import { useNavigate, useLocation, useSearchParams } from 'react-router'
import { AppLayout, TopBar } from 'prove-common'
import { AppLogo } from '../components/app-logo/AppLogo'
import { buildTitle, CodeTypes } from '../utils/codeValidation'
import { useCodeScan } from '../hooks/useCodeScan'

export const CodeScanScreen = ({ appName }: { appName: string }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type') as CodeTypes | null
  const redirectUrl = searchParams.get('redirectUrl')
  const decodedRedirect = redirectUrl ? decodeURIComponent(redirectUrl) : null

  const { scanner, manualEntry } = useCodeScan({
    type,
    context: `redirect=${decodedRedirect ?? 'none'}`,
    onCodeScanned: (code) => {
      if (!decodedRedirect) return
      navigate(decodedRedirect.replace(':code', code), {
        replace: true,
        state: { ...location.state, code }
      })
    }
  })

  return (
    <AppLayout
      topBar={
        <TopBar title={buildTitle(type)} logo={<AppLogo appName={appName} />} />
      }
    >
      {scanner}
      {manualEntry}
    </AppLayout>
  )
}
